import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Plus } from "lucide-react";
import { cn } from "../../../utils";
/**
 * The dashed "suggest a new X" row. Used by the picker's own single-kind
 * suggest affordance and by consumers that render one row per kind through
 * `renderActiveQueryPreRows`, so both look the same.
 */ export function EntityPickerSuggestRow({ title, meta, onClick, className }) {
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        onClick: onClick,
        className: cn("flex w-full items-center gap-3 rounded-md border-2 border-dashed border-input px-3 py-3 text-left transition-colors hover:bg-accent", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-9 w-9 items-center justify-center rounded-md border bg-muted/30 shrink-0",
                children: /*#__PURE__*/ _jsx(Plus, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1 min-w-0",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm font-medium",
                        children: title
                    }),
                    meta && /*#__PURE__*/ _jsx("p", {
                        className: "text-xs text-muted-foreground",
                        children: meta
                    })
                ]
            })
        ]
    });
}

//# sourceMappingURL=EntityPickerSuggestRow.js.map